module.exports = __webpack_public_path__ + "static/media/chart-pie-alt.8796d042.svg";